import { render, staticRenderFns } from "./StatusProgram.vue?vue&type=template&id=0b1755e7&scoped=true&"
import script from "./StatusProgram.vue?vue&type=script&lang=ts&"
export * from "./StatusProgram.vue?vue&type=script&lang=ts&"
import style0 from "./StatusProgram.vue?vue&type=style&index=0&id=0b1755e7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1755e7",
  null
  
)

export default component.exports